import React, { useMemo }  from 'react';
import { USER_STATES } from 'utils/Constants';

import Avatar from 'components/Misc/Avatar';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

import { useExamProfileStore } from 'store/exam/useExamProfileStore';

const Teacher = ({ progress }) => {
// Use exam's profile store
	const teacher = useExamProfileStore(state => state.teacher);

	// Find additional info
	const status = useMemo(() => USER_STATES.find(status => status.value === teacher.status), [teacher.status]);

	if (!teacher.id && !progress) {
		return (
			<div className="py-3 px-4 flex bg-red-500 text-white rounded-lg">
				Pārbaudes darbs nav piesaistīts nevienam pedagogam!
			</div>
		);
	}

	return (
		<Container className="p-4 flex items-center gap-4">
			<Avatar
				alt={teacher.fullName}
				src={teacher.avatar}
				online={teacher.online}
			/>

			<Title
				title={teacher.fullName}
				subtitle={status?.name}
				className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
			/>

			<Button
				small
				square
				icon="link"
				to={`/users/${teacher.id}`}
			/>
		</Container>
	);
};

export default Teacher;